<template>
  <div id="infoTransit-window" class="lity-hide">
    <div class="container" v-if="!loading">
      <div class="row justify-content-center">
        <div class="col-12 transit-title">
          <h3 v-t="'transito.titulo'"></h3>
          <p>{{ titulo }}</p>
          <p>{{ subTitulo }}</p>
        </div>

        <div class="col-12 transit-row">
          <div class="transit-type">
            <img src="/img/transit-car.png" alt="car" />
            <div class="transit-overlay">
              <div class="ttext">Desplazamiento vehicular a nivel</div>
            </div>
          </div>
          <div class="transit-data" v-if="transit_on_street1">
            <div class="table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="align-middle">
                      <h4>
                        <IOdometer
                          class="iOdometer"
                          :duration="3750"
                          :value="transit_on_street1"
                        />
                      </h4>
                    </td>
                    <td class="align-middle">
                      <img
                        :src="'/img/' + direccionTransitoIcon(going1)"
                        alt="Dirección"
                      />
                    </td>
                    <td class="align-middle">
                      {{ direccionTransito(going1) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="align-middle">
                      <h4>
                        <IOdometer
                          class="iOdometer"
                          :duration="3750"
                          :value="transit_on_street2"
                        />
                      </h4>
                    </td>
                    <td class="align-middle">
                      <img
                        :src="'/img/' + direccionTransitoIcon(going2)"
                        alt="Dirección"
                      />
                    </td>
                    <td class="align-middle">
                      {{ direccionTransito(going2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12 transit-row" v-if="transit_tunnel1">
          <div class="transit-type in-tunel">
            <img src="/img/transit-tunel.png" alt="car" />
            <div class="transit-overlay">
              <div class="ttext">Desplazamiento vehicular en tunel</div>
            </div>
          </div>
          <div class="transit-data">
            <div class="table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="align-middle">
                      <h4>
                        <IOdometer
                          class="iOdometer"
                          :duration="3750"
                          :value="transit_tunnel1"
                        />
                      </h4>
                    </td>
                    <td class="align-middle">
                      <img
                        :src="'/img/' + direccionTransitoIcon(going3)"
                        alt="Dirección"
                      />
                    </td>
                    <td class="align-middle">
                      {{ direccionTransito(going3) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="align-middle">
                      <h4>
                        <IOdometer
                          class="iOdometer"
                          :duration="3750"
                          :value="transit_tunnel2"
                        />
                      </h4>
                    </td>
                    <td class="align-middle">
                      <img
                        :src="'/img/' + direccionTransitoIcon(going4)"
                        alt="Dirección"
                      />
                    </td>
                    <td class="align-middle">
                      {{ direccionTransito(going4) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12 transit-row" v-if="raised_road1">
          <div class="transit-type raised-road">
            <img src="/img/transit-elevated.png" alt="car" />
            <div class="transit-overlay">
              <div class="ttext">Desplazamiento vehicular en elevado</div>
            </div>
          </div>
          <div class="transit-data">
            <div class="table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="align-middle">
                      <h4>
                        <IOdometer
                          class="iOdometer"
                          :duration="3750"
                          :value="raised_road1"
                        />
                      </h4>
                    </td>
                    <td class="align-middle">
                      <img
                        :src="'/img/' + direccionTransitoIcon(going5)"
                        alt="Dirección"
                      />
                    </td>
                    <td class="align-middle">
                      {{ direccionTransito(going5) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="align-middle">
                      <IOdometer
                        class="iOdometer"
                        :duration="3750"
                        :value="raised_road2"
                      />
                    </td>
                    <td class="align-middle">
                      <img
                        :src="'/img/' + direccionTransitoIcon(going6)"
                        alt="Dirección"
                      />
                    </td>
                    <td class="align-middle">
                      {{ direccionTransito(going6) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-12">
          <h5>{{ transit_note }}</h5>
        </div>
      </div>
    </div>
    <div class="container" v-if="loading">
      <div class="row justify-content-center">
        <div class="col-12">
          <h3 v-t="'transito.loading'"></h3>
          <vue-loading
            class="loader-transut"
            type="spin"
            color="#d9544e"
            :size="{ width: '50px', height: '50px' }"
          ></vue-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
let lity_ = null;

//mixins
import VallasMixin from "../../mixins/vallas.js";
import { VueLoading } from "vue-loading-template";
import IOdometer from "vue-odometer";
import "odometer/themes/odometer-theme-default.css";
import { setTimeout } from "timers";

export default {
  props: ["lista_espacios", "cardinal_directions", "ciudades", "types"],
  mixins: [VallasMixin],
  data() {
    return {
      titulo: "",
      subTitulo: "",
      id: "",
      location_id: "",
      transit_on_street1: 0,
      going1: "",
      transit_on_street2: 0,
      going2: "",
      transit_tunnel1: 0,
      going3: "",
      transit_tunnel2: 0,
      going4: "",
      raised_road1: 0,
      going5: "",
      raised_road2: 0,
      going6: "",
      transit_note: "",
      data_server: null,
      loading: false,
    };
  },
  components: {
    VueLoading,
    IOdometer,
  },
  methods: {
    show() {
      this.loading = true;
      // eslint-disable-next-line
      lity_ = lity("#infoTransit-window");
    },
    setInfo(data) {
      this.transit_on_street1 = data.transit_on_street1 ? 9999 : null;
      this.transit_on_street2 = data.transit_on_street2 ? 9999 : null;
      this.transit_tunnel1 = data.transit_tunnel1 ? 9999 : null;
      this.transit_tunnel2 = data.transit_tunnel2 ? 9999 : null;
      this.raised_road1 = data.raised_road1 ? 9999 : null;
      this.raised_road2 = data.raised_road2 ? 9999 : null;
      this.transit_note = data.transit_note ? "" : null;
      this.data_server = data;
      this.titulo = data.title;
      this.subTitulo = data.subtitle;
      this.id = data.id;
      this.location_id = data.location_id;
      this.going1 = data.going1;
      this.going2 = data.going2;
      this.going3 = data.going3;
      this.going4 = data.going4;
      this.going5 = data.going5;
      this.going6 = data.going6;
      this.loading = false;
      setTimeout(() => {
        this.transit_on_street1 = parseInt(data.transit_on_street1);
        this.transit_on_street2 = parseInt(data.transit_on_street2);
        this.transit_tunnel1 = parseInt(data.transit_tunnel1);
        this.transit_tunnel2 = parseInt(data.transit_tunnel2);
        this.raised_road1 = parseInt(data.raised_road1);
        this.raised_road2 = parseInt(data.raised_road2);
        this.transit_note = data.transit_note;
      }, 100);
    },
    direccionTransito(id_dir) {
      // eslint-disable-next-line
      const $t = this.$t.bind(this);
      let result = null;
      switch (id_dir) {
        case 1:
          result = this.$t("transito.sn");
          break;
        case 4:
          result = this.$t("transito.ns");
          break;
        case 2:
          result = this.$t("transito.oe");
          break;
        case 3:
          result = this.$t("transito.eo");
          break;
        default:
          result = this.$t("transito.indefinido");
          break;
      }
      return result;
    },
    direccionTransitoIcon(id_dir) {
      let result = null;
      switch (id_dir) {
        case 1:
          result = "transit-north.png";
          break;
        case 4:
          result = "transit-south.png";
          break;
        case 2:
          result = "transit-east.png";
          break;
        case 3:
          result = "transit-west.png";
          break;
        default:
          result = "transit-north.png";
          break;
      }
      return result;
    },
  },
};
</script>
 
<i18n src="@/locale/modals/traficoVehicular.json" />
